import { render, staticRenderFns } from "./TableCellOdpCreditLogAmount.vue?vue&type=template&id=08af38d2"
import script from "./TableCellOdpCreditLogAmount.vue?vue&type=script&setup=true&lang=js"
export * from "./TableCellOdpCreditLogAmount.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports